import React from 'react';
import { galleryImages } from '../data/mock';

const GallerySection = () => {
  const doubledImages = [...galleryImages, ...galleryImages];

  return (
    <section style={{
      backgroundColor: '#000',
      padding: '80px 0',
      overflow: 'hidden',
      borderTop: '1px solid rgba(255,255,255,0.06)',
    }}>
      {/* Row 1 - scroll right */}
      <div style={{ marginBottom: '8px', overflow: 'hidden' }}>
        <div style={{
          display: 'flex',
          gap: '8px',
          animation: 'galleryRight 30s linear infinite',
          width: 'max-content',
        }}>
          {doubledImages.map((img, i) => (
            <div key={i} style={{
              flexShrink: 0,
              width: '340px',
              height: '220px',
              borderRadius: '14px',
              overflow: 'hidden',
              backgroundColor: '#111',
            }}>
              <img
                src={img}
                alt=""
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  filter: 'brightness(0.8)',
                  transition: 'filter 0.3s ease, transform 0.3s ease',
                }}
                onMouseEnter={(e) => { e.target.style.filter = 'brightness(1)'; e.target.style.transform = 'scale(1.03)'; }}
                onMouseLeave={(e) => { e.target.style.filter = 'brightness(0.8)'; e.target.style.transform = 'scale(1)'; }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Row 2 - scroll left */}
      <div style={{ overflow: 'hidden' }}>
        <div style={{
          display: 'flex',
          gap: '8px',
          animation: 'galleryLeft 35s linear infinite',
          width: 'max-content',
          marginLeft: '-60px',
        }}>
          {[...doubledImages].reverse().map((img, i) => (
            <div key={i} style={{
              flexShrink: 0,
              width: '340px',
              height: '220px',
              borderRadius: '14px',
              overflow: 'hidden',
              backgroundColor: '#111',
            }}>
              <img
                src={img}
                alt=""
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  filter: 'brightness(0.8)',
                  transition: 'filter 0.3s ease, transform 0.3s ease',
                }}
                onMouseEnter={(e) => { e.target.style.filter = 'brightness(1)'; e.target.style.transform = 'scale(1.03)'; }}
                onMouseLeave={(e) => { e.target.style.filter = 'brightness(0.8)'; e.target.style.transform = 'scale(1)'; }}
              />
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes galleryRight {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes galleryLeft {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
      `}</style>
    </section>
  );
};

export default GallerySection;
